/**
 * ============================================================
 * PGLP | MONTE HERMOM
 * SERVICE: sessaoGuard
 * VERSÃO:  2.2.0
 * ------------------------------------------------------------
 * NOVIDADES v2.2.0:
 *   ✔ REMOVIDO circuit breaker (causava falsos 404)
 *   ✔ Interceptor passivo: observa 401/403, dispara evento,
 *     mas NUNCA bloqueia fetch
 *   ✔ Detecta expiração apenas por 401 ou por /api/auth/status
 *   ✔ Ignora 403 de endpoints não-auth (podem ser permissão)
 * ============================================================
 */

const EVENTO_SESSAO_EXPIRADA = 'mh:sessao-expirada';
const INTERVALO_HEARTBEAT_MS = 5 * 60 * 1000;

const EXCECOES = [
  '/api/auth/login',
  '/api/auth/logout',
  '/api/auth/status',
  '/api/auth/verificar',
  '/_debug',
];

function deveIgnorar(url) {
  if (typeof url !== 'string') return false;
  return EXCECOES.some(exc => url.includes(exc));
}

/* ---------- Disparo do evento (idempotente) ---------- */

function dispararSessaoExpirada(detalhe = {}) {
  if (typeof window === 'undefined') return;
  if (window.__mh_sessao_ja_disparada) return;

  window.__mh_sessao_ja_disparada = true;

  console.warn('[sessaoGuard] Sessão expirada detectada:', detalhe);
  window.dispatchEvent(new CustomEvent(EVENTO_SESSAO_EXPIRADA, {
    detail: detalhe,
  }));
}

/* ---------- Interceptador ---------- */

if (typeof window !== 'undefined' && !window.__mh_sessao_guard_instalado) {
  window.__mh_sessao_guard_instalado = true;

  const fetchOriginal = window.fetch.bind(window);

  window.fetch = async function (...args) {
    const [url] = args;

    /* ⚠️ SEM CIRCUIT BREAKER — sempre chama o servidor */
    const resposta = await fetchOriginal(...args);

    /* Só dispara se:
       - for 401 (não autenticado) OU
       - for 403 em endpoint de auth (sessão) */
    if (!deveIgnorar(url)) {
      const is401 = resposta.status === 401;
      const is403EmAuth = resposta.status === 403 && String(url).includes('/auth/');

      if (is401 || is403EmAuth) {
        dispararSessaoExpirada({ url, status: resposta.status });
      }
    }

    return resposta;
  };

  console.info('[sessaoGuard] Interceptador instalado (modo passivo).');

  /* ---------- Heartbeat ---------- */

  async function verificarSessao() {
    if (window.__mh_sessao_ja_disparada) return;

    try {
      const resp = await fetchOriginal('/api/auth/status.php', {
        method: 'GET',
        credentials: 'include',
        cache: 'no-store',
      });

      if (!resp.ok) return;

      const data = await resp.json();

      if (data.autenticado === false) {
        dispararSessaoExpirada({
          url: '/api/auth/status.php',
          status: resp.status,
          motivo: data.motivo || 'desconhecido',
        });
      }
    } catch (e) {
      console.debug('[sessaoGuard] Heartbeat falhou:', e.message);
    }
  }

  setTimeout(verificarSessao, 10 * 1000);
  setInterval(verificarSessao, INTERVALO_HEARTBEAT_MS);

  console.info('[sessaoGuard] Heartbeat a cada 5 min.');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') verificarSessao();
  });
}

/* ---------- API pública ---------- */

export function onSessaoExpirada(callback) {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(EVENTO_SESSAO_EXPIRADA, callback);
  return () => window.removeEventListener(EVENTO_SESSAO_EXPIRADA, callback);
}

export function emitirSessaoExpirada(detalhe = {}) {
  dispararSessaoExpirada(detalhe);
}

export function sessaoEstaBloqueada() {
  return typeof window !== 'undefined' && window.__mh_sessao_ja_disparada === true;
}

export function resetarGuard() {
  if (typeof window === 'undefined') return;
  window.__mh_sessao_ja_disparada = false;
  console.info('[sessaoGuard] Estado RESETADO.');
}

export const SESSAO_EXPIRADA_EVENT = 'mh:sessao-expirada';